<template>
  <div>
    <el-card>
      <div style="margin-bottom: 20px">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handelAdd"
          >添加</el-button
        >
      </div>
      <el-table stripe border :data="list">
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="分类名称"
          align="center"
        ></el-table-column>
        <el-table-column
          label="分类图标"
          align="center"
        >
        <template slot-scope="scope">
            <el-image
              :src="scope.row.icon"
              style="width: 80px; height: 80px"
              :preview-src-list="[scope.row.icon]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="handelEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDelClass(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[5, 10, 20, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handelSizeChange"
        @current-change="handelPage"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="type == 1 ? '新增分类' : '编辑分类'"
      :visible.sync="dialogFormVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="分类名称">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="分类图标">
          <uploadImg :limit="1" v-model="form.icon"></uploadImg>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="number" v-model="form.sort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">保 存</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { getClassList, saveClass, delClass } from "@/api";
import uploadImg from "@/components/upload-img/index.vue";
export default {
  name: "ClassList",
  components: {
    uploadImg,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogFormVisible: false,
      type: 1, //1添加 2编辑
      form: {},
    };
  },
  mounted() {
    this.handleGetClassList();
  },
  methods: {
    submit() {
      if (!this.form.title) {
        this.$message.error("分类名称不能为空");
        return;
      }
      if (!this.form.icon) {
        this.$message.error("分类图标不能为空");
        return;
      }
      if (!this.form.sort) {
        this.$message.error("排序不能为空");
        return;
      }
      let formData = new FormData();
      formData.append("title", this.form.title);
      formData.append("icon", this.form.icon);
      formData.append("sort", this.form.sort);
      formData.append("type", this.type);
      if (this.type == 2) {
        formData.append("id", this.form.id);
      }
      saveClass(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.dialogFormVisible = false;
          this.handleGetClassList();
        }
      });
    },
    handelEdit(row) {
      this.form = { ...row };
      this.type = 2;
      this.dialogFormVisible = true;
    },
    handelAdd() {
      this.form = {};
      this.type = 1;
      this.dialogFormVisible = true;
    },
    handleDelClass({ id, title }) {
      this.$confirm(`此操作将永久删除该分类【${title}】, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          delClass(formData).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleGetClassList();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleGetClassList() {
      let formData = new FormData();
      formData.append("page", this.page);
      formData.append("size", this.pageSize);
      getClassList(formData).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    handelPage(val) {
      this.page = val;
      this.handleGetClassList();
    },
    handelSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.handleGetClassList();
    },
  },
};
</script>

<style></style>
